export const GET_INVESTORS_LIST = "GET_INVESTORS_LIST";
export const GET_INVESTORS_LIST_SUCCESS = "GET_INVESTORS_LIST_SUCCESS";
export const GET_INVESTORS_LIST_FAILED = "GET_INVESTORS_LIST_FAILED";
export const GET_INVESTOR_DETAILS = "GET_INVESTOR_DETAIL";
export const GET_INVESTOR_DETAILS_SUCCESS = "GET_INVESTOR_DETAIL_SUCCESS";
export const GET_INVESTOR_DETAILS_FAILED = "GET_INVESTOR_DETAIL_FAILED";
export const FAVOURITE_INVESTOR = "FAVOURITE_INVESTOR";
export const FAVOURITE_INVESTOR_SUCCESS = "FAVOURITE_INVESTOR_SUCCESS";
export const FAVOURITE_INVESTOR_FAILED = "FAVOURITE_INVESTOR_FAILED";
export const SEARCH_INVESTORS = "SEARCH_INVESTORS";
export const SEARCH_INVESTORS_SUCCESS = "SEARCH_INVESTORS_SUCCESS";
export const SEARCH_INVESTORS_FAILED = "SEARCH_INVESTORS_FAILED";
export const GET_FUNDS_LIST = "GET_FUNDS_LIST";
export const GET_FUNDS_LIST_SUCCESS = "GET_FUNDS_LIST_SUCCESS";
export const GET_FUNDS_LIST_FAILED = "GET_FUNDS_LIST_FAILED";
export const GET_CATEGORY_LIST = "GET_CATEGORY_LIST";
export const GET_CATEGORY_LIST_SUCCESS = "GET_CATEGORY_LIST_SUCCESS";
export const GET_CATEGORY_LIST_FAILED = "GET_CATEGORY_LIST_FAILED";
export const GET_SCHEME_LIST = "GET_SCHEME_LIST";
export const GET_SCHEME_LIST_SUCCESS = "GET_SCHEME_LIST_SUCCESS";
export const GET_SCHEME_LIST_FAILED = "GET_SCHEME_LIST_FAILED";
export const VALIDATE_SUB_BROKER = "VALIDATE_SUB_BROKER";
export const VALIDATE_SUB_BROKER_SUCCESS = "VALIDATE_SUB_BROKER_SUCCESS";
export const VALIDATE_SUB_BROKER_FAILED = "VALIDATE_SUB_BROKER_FAILED";
export const STORE_TYPE = "STORE_TYPE";
export const GET_UPCOMING_SIP_DETAILS = "GET_UPCOMING_SIP_DETAILS";
export const GET_UPCOMING_SIP_DETAILS_SUCCESS =
  "GET_UPCOMING_SIP_DETAILS_SUCCESS";
export const GET_UPCOMING_SIP_DETAILS_FAILED =
  "GET_UPCOMING_SIP_DETAILS_FAILED";

export const GET_FOLIOS_CANCELLATION = "GET_FOLIOS_CANCELLATION";
export const GET_FOLIOS_CANCELLATION_FAILED = "GET_FOLIOS_CANCELLATION_FAILED";
export const GET_FOLIOS_CANCELLATION_SUCCESS =
  "GET_FOLIOS_CANCELLATION_SUCCESS";
export const SUBMIT_GET_FOLIOS_CANCELLATION = "SUBMIT_GET_FOLIOS_CANCELLATION";
export const SUBMIT_GET_FOLIOS_CANCELLATION_SUCCESS =
  "SUBMIT_GET_FOLIOS_CANCELLATION_SUCCESS";
export const SUBMIT_GET_FOLIOS_CANCELLATION_FAILED =
  "SUBMIT_GET_FOLIOS_CANCELLATION_FAILED";

export const SUBMIT_GET_STP_FOLIOS_CANCELLATION =
  "SUBMIT_GET_STP_FOLIOS_CANCELLATION";
export const SUBMIT_GET__STP_FOLIOS_CANCELLATION_SUCCESS =
  "SUBMIT_GET__STP_FOLIOS_CANCELLATION_SUCCESS";
export const SUBMIT_GET_STP_FOLIOS_CANCELLATION_FAILED =
  "SUBMIT_GET_STP_FOLIOS_CANCELLATION_FAILED";

export const PAUSE_SIP_DATES = "PAUSE_SIP_DATES";
export const PAUSE_SIP_DATES_SUCCESS = "PAUSE_SIP_DATES_SUCCESS";
export const PAUSE_SIP_DATES_FAILED = "PAUSE_SIP_DATES_FAILED";
export const PAUSE_END_SIP_DATES = "PAUSE_END_SIP_DATES";
export const PAUSE_END_SIP_DATES_SUCCESS = "PAUSE_END_SIP_DATES_SUCCESS";
export const PAUSE_END_SIP_DATES_FAILED = "PAUSE_END_SIP_DATES_FAILED";
export const PAUSE_SIP_VALIDATOR = "PAUSE_SIP_VALIDATOR";
export const PAUSE_SIP_VALIDATOR_SUCCESS = "PAUSE_SIP_VALIDATOR_SUCCESS";
export const PAUSE_SIP_VALIDATOR_FAILED = "PAUSE_SIP_VALIDATOR_FAILED";
export const FINAL_SIP_PAUSE = "FINAL_SIP_PAUSE";
export const FINAL_SIP_PAUSE_SUCCESS = "FINAL_SIP_PAUSE_SUCCESS";
export const FINAL_SIP_PAUSE_FAILED = "FINAL_SIP_PAUSE_FAILED";
export const SEND_MAIL_KYC = "SEND_MAIL_KYC";
export const SEND_MAIL_KYC_SUCCESS = "SEND_MAIL_KYC_SUCCESS";
export const SEND_MAIL_KYC_FAILED = "SEND_MAIL_KYC_FAILED";
